var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.disabled
    ? _c(
        "span",
        { class: _vm.classes },
        [
          _c("Icon", { staticClass: "left-icon", attrs: { icon: _vm.icon } }),
          _vm._v("\n\t" + _vm._s(_vm.text) + "\n")
        ],
        1
      )
    : _c(
        "a",
        {
          class: _vm.classes,
          attrs: { href: _vm.href ? _vm.href : "#" },
          on: { click: _vm.onClick }
        },
        [
          _c("Icon", {
            staticClass: "left-icon",
            attrs: { icon: _vm.icon, size: _vm.iconSize }
          }),
          _vm._v("\n\t" + _vm._s(_vm.text) + "\n")
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }